import { put, call } from "redux-saga/effects";
import { VisaCareI140CaseAPI } from "../../utils/api/VisaCareI140CaseAPI";
import {   SAVE_I140FORMS_SUCCESS,SAVE_I140FORMS_FAILED ,  
    UPDATE_I140FORMS_SUCCESS,UPDATE_I140FORMS_FAILED, 
    GET_I140FORMS_SUCCESS,GET_I140FORMS_FAILED ,     
    SAVEPDF_I140FORMS_FAILED , SAVEPDF_I140FORMS_SUCCESS,
    EXTRACT_ETA9089_SUCCESS, EXTRACT_ETA9089_FAILED,
    GET_ETA9089_SUCCESS, GET_ETA9089_FAILED,
    UPDATE_ETA9089_SUCCESS, UPDATE_ETA9089_FAILED
} from "../actions/VisaCareI140Case";

// the eta9089 APIs answer errors with a text message (or 404 with no body)
const eta9089ErrorMessage = (e: any, fallback: string) => {
    const serverMessage = e && e.response && e.response.data;
    return typeof serverMessage === "string" && serverMessage ? serverMessage : fallback;
};
 
export function* i140formsCreate(request: any) {
  
    try {
           const result=yield call(VisaCareI140CaseAPI.i140formsCreate, request.input);
         yield put({ 
            type: SAVE_I140FORMS_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_I140FORMS_FAILED, payload: e.message });
    }
}

export function* i140formsUpdate(request: any) {
   
    try {
           const result=yield call(VisaCareI140CaseAPI.i140formsUpdate, request.input);
         yield put({ 
            type: UPDATE_I140FORMS_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_I140FORMS_FAILED, payload: e.message });
    }
}
export function*getI140formsDetails (request:any) {
    try {
      
        const { data } = yield call(VisaCareI140CaseAPI.getI140formsDetails,request);
    
      yield put({
          type: GET_I140FORMS_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_I140FORMS_FAILED, payload: e.message });
    }
  }


   
  export function* i140FormPdfSubmit(request: any) {
 
    try {
           const { data }=yield call(VisaCareI140CaseAPI.i140FormPdfSubmit, request);
         yield put({ 
            type: SAVEPDF_I140FORMS_SUCCESS,     
            payload: data
            
        });
        
    } catch (e) {
        yield put({ type: SAVEPDF_I140FORMS_FAILED, payload: e.message });
    }

    
    } 

  // ETA-9089 upload -> JSON. The server answers 400 / 417 with a text message.
  export function* eta9089Extract(request: any) {
    try {
        const { data } = yield call(VisaCareI140CaseAPI.eta9089Extract, request);
        yield put({
            type: EXTRACT_ETA9089_SUCCESS,
            payload: data,
            input: request.input
        });
    } catch (e) {
        const serverMessage = e && e.response && e.response.data;
        yield put({
            type: EXTRACT_ETA9089_FAILED,
            payload: typeof serverMessage === "string" && serverMessage ? serverMessage : (e && e.message) || "ETA-9089 could not be read.",
            input: request.input
        });
    }
  }

  // stored ETA-9089 JSON of an upload; status 404 = this upload has none
  export function* getEta9089Form(request: any) {
    try {
        const { data } = yield call(VisaCareI140CaseAPI.getEta9089Form, request);
        yield put({
            type: GET_ETA9089_SUCCESS,
            payload: data,
            input: request.input
        });
    } catch (e) {
        yield put({
            type: GET_ETA9089_FAILED,
            payload: e && e.response && e.response.status === 404
                ? "No extracted data is stored for this upload. Click Extract Data to read the file."
                : eta9089ErrorMessage(e, "ETA-9089 data could not be loaded."),
            input: request.input
        });
    }
  }

  // edited ETA-9089 JSON saved over the stored one
  export function* updateEta9089Form(request: any) {
    try {
        const { data } = yield call(VisaCareI140CaseAPI.updateEta9089Form, request);
        yield put({
            type: UPDATE_ETA9089_SUCCESS,
            payload: data,
            input: request.input
        });
    } catch (e) {
        yield put({
            type: UPDATE_ETA9089_FAILED,
            payload: eta9089ErrorMessage(e, "ETA-9089 data could not be saved."),
            input: request.input
        });
    }
  }
